import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../images/birdlogo.jpeg'

const Navbar = () => {
  return (
    <div className=''>

      <nav className="navbar navbar-expand-lg navbar-dark bg-primary ">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt='' className='logo' />
        </Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto ">
            <li className="nav-item active">
              <Link className="nav-link" to="/" data-toggle="collapse" data-target="#navbarSupportedContent">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about" data-toggle="collapse" data-target="#navbarSupportedContent">About us</Link>
            </li>
            <li className="nav-item" >
              <Link className="nav-link" to="/contact" data-toggle="collapse" data-target="#navbarSupportedContent">Contact us</Link>
            </li>
            <li className="nav-item" >
              <Link className="nav-link" to="/service" data-toggle="collapse" data-target="#navbarSupportedContent">Services</Link>
            </li>


          </ul>

        </div>
      </nav>

    </div>
  )
}

export default Navbar